/* Style Adix — visit-section map.

   Default: still images from Mapbox's image service (dark style, ~20-50 KB
   WebP each). The view buttons swap between two stills — the studio, and the
   thirty mile zone — with no map engine involved at all.

   "Explore in 3D" is opt-in. Only then does Mapbox GL JS (~1.6 MB) download,
   and it opens on the same camera as the still that was showing, on the same
   dark style, with 3D buildings added — so the picture does not jump.

   There is no rotation or idle animation anywhere: a continuously redrawing
   map keeps the GPU busy for as long as the page is open. */
(function(){
  var frame=document.getElementById('adixMap');
  if(!frame) return;
  var fig=frame.closest('figure')||frame.parentNode;
  var img=frame.querySelector('.adix-map__img'),
      pin=frame.querySelector('.adix-map__pin'),
      zoneTag=frame.querySelector('.adix-map__zone'),
      exploreBtn=fig.querySelector('[data-explore]'),
      buttons=fig.querySelectorAll('[data-view]');

  var TOKEN=frame.dataset.token;
  var STUDIO=[parseFloat(frame.dataset.lng),parseFloat(frame.dataset.lat)];
  // TMZ: 30 miles from West Beverly Blvd & North La Cienega Blvd
  var TMZ=[-118.37679,34.07626], RADIUS_MI=30;
  var STYLE='mapbox/dark-v11';
  // the camera of each still; the 3D map reuses these so nothing jumps
  var CAM={
    studio:{center:STUDIO,zoom:16.4,bearing:-28,pitch:60},
    tmz:{center:TMZ,zoom:8.4,bearing:0,pitch:0}
  };
  var calm=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var current='studio', map=null, glMarker=null, glTag=null;

  /* ---------- geometry ---------- */
  function circlePts(center,miles,steps){
    var R=3958.8, lat=center[1]*Math.PI/180, lng=center[0]*Math.PI/180, d=miles/R, pts=[];
    for(var i=0;i<=steps;i++){
      var b=2*Math.PI*i/steps;
      var la=Math.asin(Math.sin(lat)*Math.cos(d)+Math.cos(lat)*Math.sin(d)*Math.cos(b));
      var lo=lng+Math.atan2(Math.sin(b)*Math.sin(d)*Math.cos(lat),Math.cos(d)-Math.sin(lat)*Math.sin(la));
      pts.push([lo*180/Math.PI,la*180/Math.PI]);
    }
    return pts;
  }
  function polyline(pts){            // Google encoded polyline, precision 5
    var out='',pl=0,pn=0;
    function enc(v){ v=v<0?~(v<<1):v<<1; var s=''; while(v>=0x20){ s+=String.fromCharCode((0x20|(v&0x1f))+63); v>>=5; } return s+String.fromCharCode(v+63); }
    for(var i=0;i<pts.length;i++){
      var la=Math.round(pts[i][1]*1e5), lo=Math.round(pts[i][0]*1e5);
      out+=enc(la-pl)+enc(lo-pn); pl=la; pn=lo;
    }
    return out;
  }
  // web-mercator position of [lng,lat] in a 640px still centred on cam
  function pct(ll,cam){
    var w=512*Math.pow(2,cam.zoom);
    function px(p){ return [(p[0]+180)/360*w,(1-Math.log(Math.tan(Math.PI/4+p[1]*Math.PI/360))/Math.PI)/2*w]; }
    var a=px(ll), c=px(cam.center);
    return [50+(a[0]-c[0])/640*100, 50+(a[1]-c[1])/640*100];
  }

  /* ---------- the two stills ---------- */
  var ZONE=circlePts(TMZ,RADIUS_MI,72);
  function stillUrl(view,scale){
    var c=CAM[view], overlay='';
    if(view==='tmz') overlay='path-3+ffffff-1+ffffff-0.08('+encodeURIComponent(polyline(ZONE))+')/';
    return 'https://api.mapbox.com/styles/v1/'+STYLE+'/static/'+overlay+
      c.center[0]+','+c.center[1]+','+c.zoom+','+c.bearing+','+c.pitch+
      '/640x640'+(scale===2?'@2x':'')+'.webp?access_token='+TOKEN;
  }
  function placeOverlays(view){
    var p=view==='studio'?[50,50]:pct(STUDIO,CAM.tmz);
    pin.style.left=p[0]+'%'; pin.style.top=p[1]+'%';
    if(view==='tmz'){
      // south edge, over the ocean: the studio sits near the north-west edge
      var z=pct([TMZ[0],TMZ[1]-RADIUS_MI/69*0.86],CAM.tmz);
      zoneTag.style.left=z[0]+'%'; zoneTag.style.top=z[1]+'%';
      zoneTag.hidden=false;
    }else{ zoneTag.hidden=true; }
  }
  function showStill(view){
    var s1=stillUrl(view,1), s2=stillUrl(view,2);
    // decode the next still off-screen first, so the swap never flashes
    var next=new Image();
    next.srcset=s1+' 640w, '+s2+' 1280w'; next.sizes=img.sizes; next.src=s1;
    var swap=function(){
      img.srcset=next.srcset; img.src=s1;
      img.alt=view==='tmz'?frame.dataset.altTmz:frame.dataset.altStudio;
      placeOverlays(view);
    };
    if(next.decode) next.decode().then(swap,swap); else next.onload=swap;
  }

  function setPressed(view){
    for(var i=0;i<buttons.length;i++) buttons[i].setAttribute('aria-pressed',buttons[i].dataset.view===view?'true':'false');
  }
  function go(view){
    if(view===current) return;
    current=view; setPressed(view);
    if(map) flyGL(view); else showStill(view);
  }
  fig.addEventListener('click',function(e){
    var b=e.target.closest('[data-view]'); if(b) go(b.dataset.view);
  });

  /* ---------- opt-in 3D ---------- */
  function load(tag,attrs){
    return new Promise(function(ok,bad){
      var el=document.createElement(tag);
      for(var k in attrs) el[k]=attrs[k];
      el.onload=ok; el.onerror=bad; document.head.appendChild(el);
    });
  }
  // the still is 640 logical px wide; match its scale in a frame of any width
  function glCam(view){
    var c=CAM[view], k=Math.log(frame.clientWidth/640)/Math.LN2;
    return {center:c.center,zoom:c.zoom+k,bearing:c.bearing,pitch:c.pitch};
  }
  function flyGL(view){
    var showZone=view==='tmz';
    if(map.getLayer('tmz-line')){
      map.setLayoutProperty('tmz-line','visibility',showZone?'visible':'none');
      map.setLayoutProperty('tmz-fill','visibility',showZone?'visible':'none');
    }
    if(showZone&&!glTag){
      var el=document.createElement('div'); el.className='adix-tmz-tag'; el.textContent='Thirty mile zone';
      glTag=new mapboxgl.Marker({element:el,anchor:'center'}).setLngLat([TMZ[0],TMZ[1]-RADIUS_MI/69*0.86]).addTo(map);
    }else if(!showZone&&glTag){ glTag.remove(); glTag=null; }
    map.flyTo(Object.assign({duration:calm?0:2200,essential:true},glCam(view)));
  }

  function explore(){
    if(map) return;
    exploreBtn.disabled=true; exploreBtn.textContent='Loading 3D…';
    var V='3.15.0';
    load('link',{rel:'stylesheet',href:'https://api.mapbox.com/mapbox-gl-js/v'+V+'/mapbox-gl.css'});
    load('script',{src:'https://api.mapbox.com/mapbox-gl-js/v'+V+'/mapbox-gl.js'}).then(start,failed);
  }
  function failed(){
    // the still stays on screen; nothing is lost
    if(exploreBtn){ exploreBtn.disabled=false; exploreBtn.textContent='3D unavailable'; exploreBtn.disabled=true; }
  }
  function start(){
    var gl=window.mapboxgl;
    if(!gl||(gl.supported&&!gl.supported())) return failed();
    gl.accessToken=TOKEN;
    var holder=document.getElementById('adixGl');
    holder.hidden=false; holder.style.visibility='hidden';
    try{
      map=new gl.Map(Object.assign({
        container:holder, style:'mapbox://styles/'+STYLE,
        cooperativeGestures:true                 // page scroll is never hijacked
      },glCam(current)));
    }catch(e){ map=null; return failed(); }
    map.addControl(new gl.NavigationControl({visualizePitch:true}),'top-right');

    var mk=document.createElement('div');
    mk.className='adix-pin';
    mk.innerHTML=pin.innerHTML;
    glMarker=new gl.Marker({element:mk,anchor:'bottom',offset:[0,6]}).setLngLat(STUDIO).addTo(map);

    map.once('style.load',function(){
      // 3D buildings, coloured to sit in the same dark palette as the still
      var labels=(map.getStyle().layers||[]).find(function(l){ return l.type==='symbol'&&l.layout&&l.layout['text-field']; });
      map.addLayer({
        id:'adix-3d-buildings', source:'composite', 'source-layer':'building',
        filter:['==','extrude','true'], type:'fill-extrusion', minzoom:14,
        paint:{
          'fill-extrusion-color':'#3A3A3A',
          'fill-extrusion-height':['interpolate',['linear'],['zoom'],14,0,15,['get','height']],
          'fill-extrusion-base':['get','min_height'],
          'fill-extrusion-opacity':0.95
        }
      },labels?labels.id:undefined);
      map.addSource('tmz',{type:'geojson',data:{type:'Feature',geometry:{type:'Polygon',coordinates:[ZONE]}}});
      map.addLayer({id:'tmz-fill',type:'fill',source:'tmz',layout:{visibility:'none'},paint:{'fill-color':'#fff','fill-opacity':0.08}});
      map.addLayer({id:'tmz-line',type:'line',source:'tmz',layout:{visibility:'none'},paint:{'line-color':'#fff','line-width':3}});
      if(current==='tmz') flyGL('tmz');
    });

    var shown=false;
    function reveal(){
      if(shown) return; shown=true;
      holder.style.visibility='';
      frame.classList.add('is-3d');
      if(exploreBtn) exploreBtn.hidden=true;
      // a gentle tilt so the buildings visibly lift off the flat still
      if(current==='studio'&&!calm) map.easeTo({pitch:66,zoom:map.getZoom()+0.25,duration:1400});
    }
    map.once('load',reveal);
    setTimeout(function(){ if(map&&map.isStyleLoaded()) reveal(); },8000);
    map.on('error',function(){ if(!shown){ holder.hidden=true; map.remove(); map=null; failed(); } });
  }
  if(exploreBtn) exploreBtn.addEventListener('click',explore);
})();
